import type { ReaderPreference } from "../api";

type OpenCCConverter = (text: string) => string;
type OpenCCGlobal = {
  Converter: (options: { from: "cn" | "tw"; to: "cn" | "tw" }) => OpenCCConverter;
};

declare global {
  interface Window {
    OpenCC?: OpenCCGlobal;
  }
}

const openCcCdnUrl = "https://cdn.jsdelivr.net/npm/opencc-js@1.0.5/dist/umd/full.js";
const converterCache = new Map<ReaderPreference["script"], OpenCCConverter>();
let openCcScriptPromise: Promise<void> | null = null;

export async function getReaderTextConverter(script: ReaderPreference["script"]): Promise<OpenCCConverter | null> {
  if (script === "source") return null;
  const cached = converterCache.get(script);
  if (cached) return cached;

  await loadOpenCcScript();
  if (!window.OpenCC) return null;

  // opencc-js 只在用户切换简繁时加载 避免默认阅读增加首屏成本
  const converter = script === "traditional"
    ? window.OpenCC.Converter({ from: "cn", to: "tw" })
    : window.OpenCC.Converter({ from: "tw", to: "cn" });

  converterCache.set(script, converter);
  return converter;
}

function loadOpenCcScript(): Promise<void> {
  if (window.OpenCC) return Promise.resolve();
  if (openCcScriptPromise) return openCcScriptPromise;

  openCcScriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");

    script.src = openCcCdnUrl;
    script.async = true;
    script.dataset.readerOpencc = "true";
    script.onload = () => resolve();
    script.onerror = () => {
      openCcScriptPromise = null;
      reject(new Error("简繁转换库加载失败"));
    };
    document.head.appendChild(script);
  });

  return openCcScriptPromise;
}
